import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  Download,
  Github,
  Linkedin,
  Mail,
} from "lucide-react";
import { usePortfolio } from "../../contexts/PortfolioContext";

const Hero = ({ isDownloading, handleDownload }) => {
  const { portfolioData } = usePortfolio();
  const personalInfo = portfolioData.personalInfo || {};
  const name = personalInfo.name || "Aurio Rajaa";
  const nameParts = name.trim().split(/\s+/);
  const firstName = nameParts.slice(0, -1).join(" ") || name;
  const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";

  const socials = [
    personalInfo.github && {
      href: personalInfo.github,
      label: "GitHub",
      icon: <Github size={18} />,
      external: true,
    },
    personalInfo.linkedin && {
      href: personalInfo.linkedin,
      label: "LinkedIn",
      icon: <Linkedin size={18} />,
      external: true,
    },
    personalInfo.email && {
      href: `mailto:${personalInfo.email}`,
      label: "Email",
      icon: <Mail size={18} />,
      external: false,
    },
  ].filter(Boolean);

  return (
    <section className="public-hero" id="hero">
      <div className="container">
        <div className="row hero-row">
          <div className="col s12 l7">
            <div className="hero-copy">
              <p className="hero-eyebrow">
                <span>{personalInfo.title || "Software Engineer"}</span>
                <span>{personalInfo.location || "Jakarta, Indonesia"}</span>
              </p>

              <h1 className="hero-title">
                {firstName}
                {lastName && (
                  <span className="hero-title-accent">{lastName}</span>
                )}
              </h1>

              <p className="hero-bio">
                {personalInfo.bio ||
                  "Software engineer focused on backend systems, cloud workflows, and thoughtful product interfaces."}
              </p>

              <div className="hero-actions">
                <Link className="btn btn-large" to="/#projects">
                  View selected work
                  <ArrowRight size={17} />
                </Link>
                <button
                  type="button"
                  className="btn btn-large btn-outline"
                  onClick={handleDownload}
                  disabled={isDownloading}
                >
                  <Download size={17} />
                  {isDownloading ? "Preparing CV..." : "Download CV"}
                </button>
              </div>

              {socials.length > 0 && (
                <div className="hero-socials" aria-label="Social links">
                  {socials.map((social) => (
                    <a
                      key={social.label}
                      className="hero-social"
                      href={social.href}
                      aria-label={social.label}
                      {...(social.external
                        ? { target: "_blank", rel: "noreferrer noopener" }
                        : {})}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>

          <div className="col s12 l5">
            <div className="hero-visual">
              <div className="hero-photo">
                <img
                  src="/profilepic.png"
                  alt={`${name} portrait`}
                  loading="eager"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
